import { render, staticRenderFns } from "./EditParticipant.vue?vue&type=template&id=10dc0db3&scoped=true"
import script from "./EditParticipant.vue?vue&type=script&lang=js"
export * from "./EditParticipant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10dc0db3",
  null
  
)

export default component.exports